module.exports = __webpack_public_path__ + "img/footerb_301.b61cb688.jpg";